function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M81.5944 88.8265C113.603 88.8265 137.285 95.0985 152.641 107.642C167.997 119.97 175.674 136.84 175.674 158.251C175.674 171.876 172.322 184.204 165.618 195.234C158.913 206.264 148.856 215.023 135.447 221.512C122.038 228 105.493 231.244 85.8118 231.244C69.5911 231.244 53.9111 228.973 38.7718 224.431C23.6325 219.673 10.8722 213.185 0.490955 204.967L18.3337 172.201C26.7685 179.122 36.8253 184.637 48.5042 188.746C60.3994 192.639 72.619 194.585 85.163 194.585C100.086 194.585 111.765 191.558 120.2 185.502C128.851 179.23 133.176 170.687 133.176 159.873C133.176 148.194 128.526 139.435 119.226 133.596C110.143 127.54 94.4628 124.512 72.1864 124.512H17.3605L29.0394 0.910312H162.373V36.2714H64.7249L59.8587 88.8265H81.5944Z"
});

function SvgMenuNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 232,
    viewBox: "0 0 176 232",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNumber);
export default __webpack_public_path__ + "static/media/menu-number.97ac1b29.svg";
export { ForwardRef as ReactComponent };